import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import api from "../api/api";
import { toast } from "react-toastify";
import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Carousel } from "react-bootstrap";
import Slider from "../components/Slider";


export default function ResetPassword() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const email = state?.email;
  const [loadingOtp, setLoadingOtp] = useState(false);

  useEffect(() => {
    if (!email) {
      navigate("/forgot-password");
    }
  }, [email, navigate]);

  if (!email) {
    return null;
  }
	const resendOtp = async () => {
	  try {
		setLoadingOtp(true);

		await api.post("/password/send-otp", { email });

		toast.success("OTP resent successfully");
	  } catch (err) {
		toast.error(err.response?.data?.error || "Failed to resend OTP");
	  } finally {
		setLoadingOtp(false);
	  }
	};

  return (
    <main className="login-screen">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-md-6 left-sec">
          <img src="images/logo.svg" className="logo" />
          <div className="link-sec">
            <Link to="/login">
              <i className="bi bi-chevron-left"></i> Back to Login
            </Link>
          </div>

          <h1 className="title1">Enter your new password</h1>
          <p className="subtitle2">
            This is the last step in recovering your password.
          </p>
           <Formik
              initialValues={{ otp: "", password: "" }}
              onSubmit={async (values) => {
                const schema = Yup.object({
                  otp: Yup.string().length(6, "OTP must be exactly 6 digits").required("OTP required"),
                  password: Yup.string()
                    .min(6, "Password must be at least 6 characters")
                    .matches(/[A-Z]/, "One uppercase required")
                    .matches(/\d/, "One number required")
                    .matches(/[!@#$%^&*]/, "One special character required")
                    .required("Password required"),
                });

                try {
                  await schema.validate(values, { abortEarly: true });
                  await api.post("/password/change", {
                    email,
                    new_password: values.password,
                    otp_code: values.otp,
                  });
                    toast.success("Password reset successful");
                    navigate("/login");
                } catch (err) {
                  if (err?.name === "ValidationError") {
                    toast.error(err.message);
                  } else {
                    toast.error(err.response?.data?.error || "Reset failed");
                  }
                }
              }}
            >
              <Form>
                <div className="input-wrapper mb-2">
                  <img src="/icons/otp.svg" alt="email" className="input-icon left" />                
                  <Field
                    className="form-control form_input"
                    name="otp"
                    type="text"
                    placeholder="Enter OTP"
                    autoComplete="one-time-code"
                    maxLength="6"
                    inputMode="numeric"
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, "").slice(0, 6);
                    }}
                  />
                  
                </div>
				

                <div className="input-wrapper mb-2">
                  <img src="/icons/shield.svg" alt="email" className="input-icon left" />                
                  <Field
                    className="form-control form_input"
                    type="password"
                    name="password"
                    placeholder="New Password"
                    autoComplete="new-password"
                  />
                  
                </div>
				<div className="footer-text mt-2">
				  <a
					href="#"
					onClick={(e) => {
					  e.preventDefault();
					  if (!loadingOtp) resendOtp();
					}}
					className={loadingOtp ? "disabled" : ""}
				  >
					{loadingOtp ? "Sending..." : "Resend OTP"}
				  </a>
				</div>
                {/* <Field
                  name="otp"
                  className="form-control mb-2"
                  placeholder="Enter OTP"
                />
                <ErrorMessage name="otp" className="text-danger" component="div" />

                <Field
                  type="password"
                  name="password"
                  className="form-control mb-2"
                  placeholder="New Password"
                />
                <ErrorMessage name="password" className="text-danger" component="div" /> */}

                <button className="btn-style1 mt-4">
                  Reset Password
                </button>
              </Form>
            </Formik>
        </div>
           <div className="col-md-6">
              <Slider className="login-slider">
            <Carousel.Item>
              <img src="images/slide1.png" className="img-fluid" />
              <Carousel.Caption>
                <h2>Forgot your password?</h2>
                <p>You can get them back easily.</p>
              </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item>
              <img src="images/slide2.png" className="img-fluid" />
              <Carousel.Caption>
                <h2>Slide 2</h2>
                <p>Slide 2 subtext</p>
              </Carousel.Caption>
            </Carousel.Item>
          </Slider>
        </div>
      </div>
    </div>
    </main>
  ); 
}
